<template>
  <div class="order-page">
    <van-tabs v-model="active" :before-change="beforeChange">
      <van-tab v-for="tab of tabs" :key="tab" :title="tab">

        <van-empty v-if="!orderList || orderList.length < 1" description="暂无数据"></van-empty>

        <order-list-detail :order-detail="orderList" order-list-url="ticket-order-list">
          <template #order-ext-info="prop">
            <div v-if="prop.orderInfo.goods.length > 0" style="flex: 1;text-align: right;margin-top: 8px">
              <van-button size="small" type="danger" @click="visibleCardInfoClick(prop.orderInfo.goods)">查看券码</van-button>
            </div>
          </template>
        </order-list-detail>
      </van-tab>
    </van-tabs>

    <van-dialog v-model="visibleCardInfo" :closeOnClickOverlay="true" :showConfirmButton="false" class="card-info">
      <van-swipe>
        <van-swipe-item v-for="(card, index) in tickets" :key="index" class="card-info-item">
          <div class="title">消费券码{{ index + 1 }}<span
              style="font-size: 22px;color: #999;font-weight: normal;margin-left: 4px;">/{{ tickets.length }}</span>
          </div>
          <div class="sub-title">请向商家出示券码消费</div>
          <div :class="card.codeImage ? 'content-img' : 'content'">
            <span v-if="card.code" class="copy-orderid">{{ card.code }}</span>
            <a v-if="card.codeUrl" :href="card.codeUrl" target="_blank">打开链接查看</a>
            <van-image v-if="card.codeImage" :src="card.codeImage" height="100" width="100">
              <template v-slot:error><a v-if="card.codeImage" :href="card.codeImage" target="_blank">打开链接查看</a>
              </template>
            </van-image>
          </div>

          <div style="margin-top: 4px;width: 100%;text-align: center">
            本消费券 <span v-if="card.status === true" style="font-weight: bold;color: #FF3814">已消费</span>
            <span v-if="card.status === false" style="font-weight: bold;color: #42b983">未消费</span>
          </div>

          <div class="btn">
            <van-button v-if="card.code" round size="small" type="default"
              @click="copy()">&nbsp;&nbsp;复制券号&nbsp;&nbsp;</van-button>
            &nbsp;&nbsp;
            <van-button v-if="card.status === false" round size="small" type="danger"
              @click="updateStatus(card.orderTicketId, true)">&nbsp;&nbsp;标记为已消费&nbsp;&nbsp;
            </van-button>
            <van-button v-if="card.status === true" round size="small" type="default"
              @click="updateStatus(card.orderTicketId, false)">&nbsp;&nbsp;取消标记&nbsp;&nbsp;
            </van-button>
          </div>

          <div class="notice">
            消费券验证状态可能有延时，如您确认已在商家消费，可自行标注已消费，以免混淆
          </div>
        </van-swipe-item>
      </van-swipe>
    </van-dialog>
  </div>
</template>

<script>
import OrderListDetail from "@/views/user-center/order-list/goods/order-list-detail";
import { getOrderTicketList, update_ticket_order_status } from "@/api/goods-api";

export default {
  name: "ticket-order-list",

  components: { OrderListDetail },

  data() {
    return {
      active: 1,
      orderList: [],
      tabs: ['全部', '待支付', "已支付", "已完成", "已取消"],
      statusOrder: null,
      statusPay: null,
      orderType: 1,
      visibleCardInfo: false,
      tickets: []
    }
  },

  props: {
    orderTitle: { type: String, default: '订单列表' }
  },

  created() {
    this.active = parseInt(this.$route.query.tabIndex || 0, 10)
    this.beforeChange(this.active);
  },

  methods: {
    visibleCardInfoClick(tickets) {
      this.tickets = tickets;
      this.visibleCardInfo = true;
    },

    updateStatus(id, status) {
      update_ticket_order_status(id, status).then(res => {
        if (res.code === 0) {
          const ticket = this.tickets.find(t => t.orderTicketId === id);
          if (ticket) {
            ticket.status = status;
          }
        }
      });
    },

    beforeChange(index) {
      this.active = index
      if (index === 1) {
        this.statusOrder = 0
        this.statusPay = 0
      } else if (index === 2) {
        this.statusPay = 1
        this.statusOrder = ''
      } else if (index === 3) {
        this.statusOrder = 4
        this.statusPay = 1
      } else if (index === 4) {
        this.statusOrder = 3
        this.statusPay = ''
      } else {
        this.statusOrder = ''
        this.statusPay = ''
      }
      this.getOrders();
    },

    getOrders() {
      getOrderTicketList(this.statusOrder, this.statusPay, 1, 10).then(res => {
        this.setOrderList(res.data.records);
      })
    },

    setOrderList(data) {
      this.orderList = data.map((item) => {
        let time = item.createTime.split("-").join("/");
        item.countDown =
          new Date(time).setMinutes(new Date(time).getMinutes() + 10) -
          new Date();
        return item;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
@import "order-list";

::v-deep .van-overlay {
  background-color: rgba(0, 0, 0, .1);
}

.card-info {
  text-align: center;

  .title {
    font-size: 28px;
    padding: 8px;
    font-weight: bold;
  }

  .sub-title {
    font-size: 12px;
    color: #666;
  }

  .content {
    padding: 16px;
    margin: 32px;
    background-color: #E9E9E9;
  }

  .content-img {
    padding: 8px;
    margin: 16px;
    background-color: #E9E9E9;
  }

  .btn {
    margin-top: 32px;
  }

  .notice {
    font-size: 12px;
    margin: 8px 16px;
    line-height: 30px;
    color: #999999;
  }

  .card-info-item {
    height: 350px;
  }
}
</style>
